import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconType, MotiIcon } from 'src/moti/models/moti-icon';
import {PopoverMessageComponent} from '../popover-message/popover-message.component';


@Component({
  selector: 'moti-info-circle',
  templateUrl: './info-circle.component.html',
  styleUrl: './info-circle.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMessageComponent,
  ],
})
export class InfoCircleComponent {
  @Input() infoText: string;
  @Input() infoHtml: string;
  @Input() icon: MotiIcon = {type: IconType.FontAwesome, id: 'info-circle'};
}
